'use client'

import Button, { buttonClassNames } from '@components/primitives/Button'
import Link from '@components/primitives/Link'
import { classMerge } from '@components/utilities/classMerge'
import type { ColorGroup } from '@lib/colors/colors'
import urlWithQueryParams from '@lib/routes/helpers/urlWithQueryParams'
import { usePathname, useSearchParams } from 'next/navigation'

export const SignInBtn = ({
  colorGroup = 'black',
  label,
  route,
}: {
  colorGroup: ColorGroup
  label: string
  route: string
}) => {
  const path = usePathname()
  const query = useSearchParams()
  const queryObject = Object.fromEntries(query?.entries() ?? [])

  const href = urlWithQueryParams(route, {
    redirect: path ?? '',
    ...queryObject,
  })

  const buttonStyle =
    colorGroup === 'black'
      ? buttonClassNames.legacy.fill.black
      : buttonClassNames.legacy.outline.white

  return (
    <Link className='m-2 flex-1 sm:m-0 sm:mr-2' href={href}>
      <Button className={classMerge(buttonStyle, 'h-[50px] w-32 rounded-full')}>
        <span className='px-4 text-base font-bold'>{label}</span>
      </Button>
    </Link>
  )
}
